import { render, staticRenderFns } from "./TrainingVideos.vue?vue&type=template&id=78d0382e"
import script from "./TrainingVideos.vue?vue&type=script&lang=ts"
export * from "./TrainingVideos.vue?vue&type=script&lang=ts"
import style0 from "./TrainingVideos.vue?vue&type=style&index=0&id=78d0382e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports